import { render, staticRenderFns } from "./invoice-transaction.vue?vue&type=template&id=eb6c84cc&"
import script from "./invoice-transaction.vue?vue&type=script&lang=js&"
export * from "./invoice-transaction.vue?vue&type=script&lang=js&"
import style0 from "./invoice-transaction.vue?vue&type=style&index=0&id=eb6c84cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports